export default "__VITE_ASSET__l$my6Dfc__"